import clsx from 'clsx';
import { FC, useEffect, useRef } from 'react';

import Button from 'components/atoms/Button';
import { ButtonModes } from 'constants/ButtonModes';
import { AppLink } from 'types/AppLink';
import { useIsVisible } from 'hooks/useIsVisible';

interface Props {
  className?: string;
  link: AppLink;
  isActive: boolean;
}

const INTERSECTION_OPTIONS: IntersectionObserverInit = {
  threshold: 1.0,
};

export const SubNavigationLink: FC<Props> = ({ className, link, isActive }) => {
  const ref = useRef<HTMLLIElement>(null);

  const isVisible = useIsVisible(ref, INTERSECTION_OPTIONS);

  useEffect(() => {
    if (isActive && !isVisible) {
      ref.current?.parentElement?.scrollTo({
        behavior: 'smooth',
        left: ref.current.offsetLeft,
      });
    }
  }, [isActive]);

  return (
    <li
      ref={ref}
      className={clsx(
        className,
        'mr-4 list-none tablet:mr-6 shrink-0 snap-start scroll-m-6'
      )}
    >
      <Button
        size="small"
        mode={isActive ? ButtonModes.primary : ButtonModes.secondaryWhite}
        href={link.href}
      >
        {link.text}
      </Button>
    </li>
  );
};
